import Notification from './Notification';
import './Notification.scss';

export default Notification;
